<template>
  <div class="page-container">
    <div class="error-404-view">
      <div class="container">
        <div class="title-error-view col-12">
          <h2 class="col-12">Ops! Este link não está disponível.</h2>
          <p class="col-12 text-default">
            Para mais informações, fale com seu contador.
          </p>
        </div>
        <div class="imagem-error-view col-12 my-5">
          <img
            alt="Página não encontrada"
            src="@/assets/images/pagina-nao-encontrada.svg"
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Footer from '@/components/Organisms/Footer.vue'

  export default defineComponent({
    name: 'Error404SproLinkView',
    components: {
      Footer,
    },
  })
</script>

<style lang="stylus" scoped>
  .page-container
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    padding-top: 200px;

  .text-default
    font-size: 1rem;
</style>
